import React, { useContext as useContextCore } from 'react'
import { useCustomer } from '../../../hooks/useCustomer'

const context = React.createContext(null)
const CoreProvider = context.Provider

export const Provider = ({ children, ...props }) => {
  const customerDocument = useCustomer()

  return <CoreProvider value={{ ...props, ...customerDocument }}>{children}</CoreProvider>
}

export const useContext = () => useContextCore(context)
